import React from 'react';

import queryString from 'query-string';
import { Link, useLocation } from 'react-router-dom';

import LayoutMain from 'components/layouts/LayoutMain';
import { TEXT_FORGOT_PASSWORD } from 'constants/string/texts';
import EnterEmailInfomation from 'pages/ResetPassword/EnterEmailInfomation';
import EnterNewPassword from 'pages/ResetPassword/EnterNewPassword';
import AppRoutes from 'routes/routes';

const ResetPassword = () => {
  const location = useLocation();
  const { search } = location;
  const queryParams = queryString.parse(search);

  return (
    <LayoutMain className={'min-h-main !py-8'}>
      {!queryParams?.token && (
        <div className="back flex mb-8">
          <Link to={AppRoutes.login} className="flex items-center gap-2">
            <img src={require('assets/resources/ArrowLeft.svg').default} alt="back" width={22} height={22} />
            <span className="text-sm text-black-102 ">{TEXT_FORGOT_PASSWORD.BACK_TO_LOGIN}</span>
          </Link>
        </div>
      )}
      <section data-testid="reset-password" id="reset-password">
        <h2 className="font-bold text-xl text-black-102 text-center">
          {queryParams?.token ? TEXT_FORGOT_PASSWORD.CONFIRM_NEW_PASSWORD : TEXT_FORGOT_PASSWORD.SEND_PASSWORD_TO_MAIL}
        </h2>
        <div className="w-indicators mx-auto mt-8">
          {queryParams?.token ? <EnterNewPassword token={queryParams?.token || ''} /> : <EnterEmailInfomation />}
        </div>
      </section>
    </LayoutMain>
  );
};

export default React.memo(ResetPassword);
